const Main = () => import(/* webpackChunkName: "g-main" */ '@/components/Main')
const TenantList = () => import(/* webpackChunkName: "g-tenant-list" */ '@/components/info/TenantList')
const TenantInfo = () => import(/* webpackChunkName: "g-tenant-info" */ '@/components/info/TenantInfo')
const MoreInfo = () => import(/* webpackChunkName: "g-tenant-info" */ '@/components/info/MoreInfo')

const mainRoutes = {
  path: '/main',
  name: 'Main',
  component: Main,
  redirect: '/info/TenantList',
  children: [
  ]
}

const tenantListRoutes = {
  path: '/info/TenantList',
  name: 'TenantList',
  component: TenantList
}

const tenantInfoRoutes = {
  path: '/info/TenantInfo',
  name: 'TenantInfo',
  component: TenantInfo
}

const moreInfoRoutes = {
  path: '/info/MoreInfo',
  name: 'MoreInfo',
  component: MoreInfo
}

export const routes = [
  {
    path: '/',
    component: {
      template: '<router-view></router-view>'
    },
    redirect: { name: 'Main' },
    children: [
      mainRoutes,
      tenantListRoutes,
      tenantInfoRoutes,
      moreInfoRoutes
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js